<template>
  <div>
    <template>
      <v-layout row wrap class="mt-3">
        <v-flex xs12 sm6>
          <div style="float: left">
            <v-menu offset-y>
              <template #activator="{ on }">
                <v-btn color="gray" outline v-on="on">
                  {{ filter.label }}
                  <i
                    class="fa fa-sort-desc ml-2"
                    style="font-size: 16px; margin-bottom: 6px"
                    aria-hidden="true"
                  />
                </v-btn>
              </template>
              <v-list>
                <v-list-tile
                  v-for="(item, index) in menu"
                  :key="index"
                  @click="onChangeFilter(item)"
                >
                  <v-list-tile-title>{{ item.label }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </div>
          <!-- sort by date -->
          <div style="float: left">
            <v-menu offset-y>
              <template #activator="{ on }">
                <v-btn color="gray" outline v-on="on">
                  เรียงลำดับตาม
                  <i
                    class="fa fa-sort-desc ml-2"
                    style="font-size: 16px; margin-bottom: 6px"
                    aria-hidden="true"
                  />
                </v-btn>
              </template>
              <v-list>
                <v-list-tile
                  v-for="(item, index) in sorts"
                  :key="index"
                  @click="onChangeSort(item)"
                >
                  <v-list-tile-title>{{ item.label }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </div>
        </v-flex>
        <v-flex xs12 class="text-xs-right">
          <v-btn outline color="primary" @click="showScheduleHolidays = true">
            <span>วันปิดทำการ</span>
          </v-btn>
          <v-btn outline color="primary" @click="showQuereManagement = true">
            <span>จัดการคิวช่าง</span>
          </v-btn>

          <v-dialog v-model="showScheduleHolidays" persistents width="400px">
            <v-card class="pa-2">
              <div class="text-xs-right">
                <v-btn icon ripple @click="showScheduleHolidays = false">
                  <v-icon>close</v-icon>
                </v-btn>
              </div>

              <div class="my-2">
                <div>กรุณาเลือกวันปิดทำการ</div>
                <div class="red--text" style="font-size: 12px">
                  * ระบบจะไม่แสดงวันดังกล่าวในการเลือกวันติดตั้ง
                </div>
              </div>
              <div class="text-xs-center">
                <v-date-picker
                  v-model="scheduleHolidays"
                  color="primary"
                  multiple
                  :show-current="false"
                  full-width
                  no-title
                ></v-date-picker>
              </div>
              <div class="text-xs-center mt-2">
                <v-btn text ripple color="primary" :loading="loading" @click="onSaveHolidays">
                  <span>{{ $t('Save') }}</span>
                </v-btn>
              </div>
            </v-card>
          </v-dialog>

          <v-dialog v-model="showQuereManagement" persistents width="400px">
            <v-card class="pa-2">
              <div class="text-xs-right">
                <v-btn icon ripple @click="onCloseQuereManagementDialog">
                  <v-icon>close</v-icon>
                </v-btn>
              </div>
              <div class="my-2">
                <div>กรุณาเลือกวันที่ต้องการจัดการจำนวนคิวช่าง</div>
                <div class="red--text" style="font-size: 12px">
                  * ระบบจะไม่สามารถเลือกวันที่ปิดทำการได้
                </div>
              </div>
              <div class="text-xs-center">
                <v-date-picker
                  v-model="selectedDateQueue"
                  color="primary"
                  :allowed-dates="allowedDates"
                  :show-current="false"
                  full-width
                  no-title
                  @input="onCheckQuotaOrder"
                ></v-date-picker>
              </div>
              <div v-if="qtyQuotaOrder" class="mt-4 mb-2">
                <div class="text-xs-center mb-2">ตั้งค่าจำนวนคิว</div>
                <v-flex shrink class="text-xs-center" style="white-space: nowrap">
                  <div style="display: inline-block">
                    <v-btn
                      small
                      fab
                      color="primary"
                      outline
                      class="extra-small ma-0"
                      :disabled="qtyQuotaOrder == minOrder"
                      @click="reduceOrder()"
                    >
                      <span class="fa fa-minus"></span>
                    </v-btn>

                    <span
                      style="
                        width: 30px;
                        display: inline-block;
                        margin-left: 5px;
                        margin-right: 5px;
                        text-align: center;
                      "
                      >{{ qtyQuotaOrder }}</span
                    >
                    <v-btn
                      small
                      fab
                      color="primary"
                      outline
                      class="extra-small ma-0"
                      @click="addOrder()"
                    >
                      <span class="fa fa-plus"></span>
                    </v-btn>
                  </div>
                </v-flex>
              </div>
              <div class="text-xs-center mt-2">
                <v-btn text ripple color="primary" :loading="saveloading" @click="onSaveQueue">
                  <span>{{ $t('Save') }}</span>
                </v-btn>
              </div>
            </v-card>
          </v-dialog>
        </v-flex>

        <!-- <v-flex xs12 sm6 style="text-align: -webkit-right">
          <div
            class="form-control pa-1"
            style="position: relative; width: 300px"
            :class="{ 'has-error': errors.has('search') }"
          >
            <input
              style="padding-left: 30px"
              :data-vv-as="$t('Search')"
              name="Search"
              placeholder="Search"
              v-model="search"
              class="form-control"
              type="text"
            />
            <div style="position: absolute; left: 10px; top: 16px">
              <v-icon>search</v-icon>
            </div>
          </div>
        </v-flex> -->
      </v-layout>
      <div style="display: flex; justify-content: space-between">
        <div>
          <v-select
            dense
            :items="numberPerPageOptions"
            label="จำนวนข้อมูลที่แสดงผล"
            solo
            @change="onChangeNumberOfPage"
          ></v-select>
        </div>
        <div style="text-align: -webkit-right">
          <v-btn color="primary" @click="showSearch">
            <v-icon>search</v-icon> {{ $t('advanced search') }}
          </v-btn>
          <v-btn color="primary" @click="exportData">{{ $t('export') }}</v-btn>
        </div>
      </div>
      <v-layout wrap>
        <v-flex xs6 class="primary--text pt-3" style="font-size: 18px">
          <span style="font-weight: 700">ทั้งหมด: &nbsp;{{ total }}&nbsp; ออเดอร์</span>
        </v-flex>
        <v-flex xs6 class="text-xs-right">
          <v-pagination
            v-model="pageNumber"
            :total-visible="8"
            :length="pagelength"
            @input="changePage"
          ></v-pagination>
        </v-flex>
      </v-layout>
      <v-data-table
        v-model="selected"
        :loading="loading"
        :headers="headers"
        :items="orders"
        :pagination.sync="pagination"
        item-key="name"
        class="elevation-1 mt-3"
        hide-actions
      >
        <template #items="props">
          <tr
            :class="{ satisfactionTrue: props.item.satisfactionstatus }"
            class="cursor-pointer"
            @click="
              detaildata = props.item
              detailToggle = true
            "
          >
            <td>{{ props.item.name || '-' }}</td>
            <td>{{ getProductName(props.item) || '-' }}</td>
            <td>
              <div style="width: 160px">
                {{ props.item.pcname || '-' }}&nbsp;{{
                  props.item.pcbranch && props.item.pclocation
                    ? '(' + props.item.pclocation + ', ' + props.item.pcbranch + ')'
                    : ''
                }}
              </div>
            </td>
            <td>{{ props.item.amount || '-' }}</td>
            <td>
              <v-btn
                flat
                color="primary"
                :disabled="['installation', 'so'].includes($store.state.privilege.role)"
                @click.stop="showCalendar(props.item)"
              >
                <em class="far fa-calendar mr-2" />
                {{ props.item.appointmentdate | DateFormat('DD/MM/YYYY') }}
              </v-btn>
            </td>
            <td class="py-1">
              {{ props.item.address }} {{ `เขต${props.item.district}` }}
              {{ `แขวง${props.item.subdistrict}` }} {{ `${props.item.zipcode}` }}
              {{ `จังหวัด${props.item.province}` }}
            </td>
            <td>{{ props.item.phonenumber || '-' }}</td>
            <td @click.stop="">
              <Multiselect
                v-model="props.item.adminstatus"
                :allow-empty="false"
                :placeholder="$t('select_option')"
                :searchable="false"
                :options="adminstatusOptions"
                :show-labels="false"
                :disabled="['installation', 'so'].includes($store.state.privilege.role)"
                @input="onChangeStatus($event, props.item)"
              ></Multiselect>
            </td>
            <td @click.stop="">
              <v-checkbox
                v-model="props.item.checklist"
                :disabled="['installation'].includes($store.state.privilege.role)"
                @change="onChecklist($event, props.item)"
              ></v-checkbox>
            </td>
            <td @click.stop="">
              <v-checkbox
                v-model="props.item.document_check_list"
                :disabled="['so'].includes($store.state.privilege.role)"
                @change="onDocumentChecklist($event, props.item)"
              ></v-checkbox>
            </td>
            <td @click.stop="">
              <AppointmentTimeSelect
                :appointment-data="appointmentData"
                :valuedata="props.item"
                :appointmentdate="props.item.appointmentdate"
                :current_appointmenttime.sync="props.item.appointmenttime"
                @onsavedata="onsavetime"
              >
              </AppointmentTimeSelect>
            </td>
            <td class="pt-2" @click.stop="">
              <v-select
                v-model="props.item.technicianid"
                :disabled="
                  !props.item.checklist ||
                  !props.item.document_check_list ||
                  ['installation', 'so'].includes($store.state.privilege.role)
                "
                :items="filteredTechnician"
                item-text="name"
                item-value="id"
                hide-no-data
                hide-details
                :placeholder="$t('select_option')"
                solo
                style="width: 200px"
              ></v-select>
              <v-btn
                icon
                flat
                color="primary"
                :disabled="
                  ['installation', 'so'].includes($store.state.privilege.role) ||
                  !props.item.checklist ||
                  !props.item.document_check_list
                "
                @click="onChangeTechnichian(props.item.technicianid, props.item)"
              >
                <v-icon>save</v-icon>
              </v-btn>
            </td>

            <!-- <td>{{ props.item.admin || '-' }}</td> -->
            <td>
              <v-btn
                color="primary"
                :disabled="!props.item.satisfactionstatus"
                flat
                @click.stop="showSatisfaction(props.item)"
                >คะแนน</v-btn
              >
            </td>
          </tr>
        </template>
      </v-data-table>
    </template>
    <v-dialog v-model="searchDialog" persistent width="650px">
      <v-card>
        <div class="text-xs-right">
          <v-btn icon @click="searchDialog = false"> <v-icon>close</v-icon></v-btn>
        </div>
        <div class="px-3 pb-4">
          <v-layout row wrap>
            <v-flex xs12 class="form-control pb-2">
              <div>ชื่อลูกค้า</div>
              <input v-model="filtersearch.name" type="text" />
            </v-flex>
            <v-flex xs6 class="form-control pr-1">
              <div>วันที่สร้างคำสั่งซื้อ</div>
              <DatepickerCustomDialog v-model="filtersearch.start_create_date">
                <input
                  readonly
                  :value="filtersearch.start_create_date"
                  type="text"
                  placeholder="วันที่เริ่มต้น"
                />
              </DatepickerCustomDialog>
            </v-flex>
            <v-flex xs6 class="form-control pl-1">
              <div>&nbsp;</div>
              <DatepickerCustomDialog v-model="filtersearch.end_create_date">
                <input
                  readonly
                  :value="filtersearch.end_create_date"
                  type="text"
                  placeholder="วันที่สิ้นสุด"
                />
              </DatepickerCustomDialog>
            </v-flex>
            <v-flex xs6 class="form-control pr-1">
              <div>วันนัดติดตั้ง</div>
              <DatepickerCustomDialog v-model="filtersearch.start_appointment_date">
                <input
                  readonly
                  :value="filtersearch.start_appointment_date"
                  type="text"
                  placeholder="วันที่เริ่มต้น"
                />
              </DatepickerCustomDialog>
            </v-flex>
            <v-flex xs6 class="form-control pl-1">
              <div>&nbsp;</div>
              <DatepickerCustomDialog v-model="filtersearch.end_appointment_date">
                <input
                  readonly
                  :value="filtersearch.end_appointment_date"
                  type="text"
                  placeholder="วันที่สิ้นสุด"
                />
              </DatepickerCustomDialog>
            </v-flex>
            <v-flex xs6 class="form-control">
              <div>เวลานัดติดตั้ง</div>
              <v-radio-group v-model="filtersearch.appointmenttime" row>
                <v-radio :label="'ช่วงเช้า'" :value="'เช้า'" color="primary"></v-radio>
                <v-radio :label="'ช่วงบ่าย'" :value="'บ่าย'" color="primary"></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex xs12 class="form-control pb-2">
              <div>เบอร์โทรศัพท์</div>
              <input v-model="filtersearch.phonenumber" type="number"
            /></v-flex>
            <v-flex xs12 class="form-control pb-2">
              <div>ชื่อช่าง</div>
              <input v-model="filtersearch.technicianname" type="text" />
            </v-flex>
            <v-flex xs12 class="form-control pb-2">
              <div>ชื่อสินค้า</div>
              <input v-model="filtersearch.product" type="text"
            /></v-flex>
            <v-flex xs12>
              <div>การประเมินความพึงพอใจ</div>
              <v-radio-group v-model="filtersearch.satisfactionStatus" row>
                <v-radio :key="1" :label="'มี'" :value="true" color="primary"></v-radio>
                <v-radio :key="2" :label="'ไม่มี'" :value="false" color="primary"></v-radio>
                <v-radio :key="3" :label="'ทั้งหมด'" :value="null" color="primary"></v-radio>
              </v-radio-group>
            </v-flex>
          </v-layout>
          <v-layout wrap class="form-control">
            <v-flex xs12>
              <div class="text-xs-center">
                <v-btn
                  color="primary"
                  style="width: 200px"
                  :loading="loading"
                  depressed
                  @click="onSearch"
                  >{{ $t('Search') }}</v-btn
                >
                <v-btn color="grey" outline style="width: 200px" @click="clearSearch">{{
                  $t('Clear Search')
                }}</v-btn>
              </div>
            </v-flex>
          </v-layout>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="detailToggle" width="600px" persistent>
      <detaildialog
        v-if="detailToggle"
        :detaildata="detaildata"
        @closeDetailToggle="detailToggle = false"
      ></detaildialog>
    </v-dialog>
    <v-dialog v-model="satisfactionDialog" width="600px" persistent>
      <v-card v-if="satisfactionDialog">
        <Satisfaction
          :detaildata="satisfactionData"
          @close="satisfactionDialog = false"
        ></Satisfaction>
      </v-card>
    </v-dialog>
    <v-dialog v-model="reasonDialog" persistent width="600px">
      <v-card>
        <div class="text-xs-right">
          <v-btn icon @click="reasonDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <div class="px-3 pb-3">
          <div class="form-control" :class="{ 'has-error': errors.has('reason') }">
            <div style="font-weight: bold; font-size: 17px" class="mb-2">ระบุเหตุผลที่ยกเลิก</div>
            <AutoresizeTextarea
              v-model="reasonText"
              v-validate="'required'"
              :data-vv-as="'เหตุผลที่ยกเลิก'"
              name="reason"
            />
            <span v-if="errors.has('reason')" class="text-error">{{ errors.first('reason') }}</span>
            <div class="text-center">
              <v-btn outline color="grey" @click="closeReasonDialog">{{ $t('cancel') }}</v-btn>
              <v-btn depressed color="primary" @click="submitStatus('ยกเลิก', reasonData)">{{
                $t('Save')
              }}</v-btn>
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="calendar_dialog" width="500px" persistent>
      <v-card v-if="calendar_dialog">
        <div class="text-xs-right">
          <v-btn icon @click="calendar_dialog = false"><v-icon>close</v-icon></v-btn>
        </div>
        <OrderCalendar :detaildata="calendar_data" @onsave="onsavecalendar"></OrderCalendar>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import AutoresizeTextarea from '@/components/elements/AutoresizeTextarea.vue'
import DatepickerCustomDialog from '@/components/elements/DatepickerCustomDialog.vue'
import config from '@/config'
import axios from 'axios'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'
import XLSX from 'xlsx'
import AppointmentTimeSelect from './AppointmentTimeSelect.vue'
import detaildialog from './Detaildialog'
import OrderCalendar from './OrderCalendar.vue'
import Satisfaction from './Satisfaction.vue'
export default {
  components: {
    detaildialog,
    Multiselect,
    Satisfaction,
    AutoresizeTextarea,
    OrderCalendar,
    AppointmentTimeSelect,
    DatepickerCustomDialog
  },
  data() {
    return {
      filtersearch: {
        name: '', // ชื่อลูกค้า
        start_create_date: '', // YYYY-MM-DD
        end_create_date: '', // YYYY-MM-DD
        start_appointment_date: '', // YYYY-MM-DD
        end_appointment_date: '',
        appointmenttime: '', // เช้า, บ่าย
        phonenumber: '',
        technicianname: '', // ชื่อช่าง
        product: '', // ชื่อสินค้า,
        satisfactionStatus: null
      },
      searchDialog: false,
      appointmentData: {},
      adminstatusOptions: ['ทีมจัดของ assign ช่าง', 'วัดหน้างาน', 'ช่างเข้างาน', 'ยกเลิก'],
      satisfactionData: '',
      satisfactionDialog: false,
      calendar_data: '',
      calendar_dialog: false,
      reasonDialog: false,
      reasonData: '',
      reasonText: '',
      search: '',
      total: 0,
      offset: 0,
      limit: 10,
      pagetmp: 1,
      pageNumber: 1,
      technician: [],
      loading: false,
      filter: {
        label: 'ทั้งหมด',
        value: 'All'
      },
      sort: {
        label: 'ทั้งหมด',
        value: 'All'
      },
      detailToggle: false,
      detaildata: '',
      pagination: {
        rowsPerPage: -1
      },
      selected: [],
      headers: [
        { text: 'ชื่อ', value: 'name', width: '2%', sortable: false },
        { text: 'สินค้า', value: 'productdetails', width: '2%', sortable: false },
        { text: 'ชื่อ PC', value: 'pcname', width: '7%', sortable: false },
        { text: 'จำนวนคิว', value: 'amount', width: '1%', sortable: false },
        { text: 'วันจัดส่ง', value: 'appointmentdate', width: '1%', sortable: false },
        { text: 'สถานที่', value: 'address', width: '1%', sortable: false },
        { text: 'เบอร์ติดต่อ', value: 'phonenumber', width: '1%', sortable: false },
        { text: 'สถานะ', value: 'adminstatus', width: '7%', sortable: false },
        { text: 'สินค้าครบ', value: 'count', width: '1%', sortable: false },
        { text: 'เอกสารครบ', value: 'count', width: '1%', sortable: false },
        { text: 'ช่วงเวลา', value: 'lenght', width: '2%', sortable: false },
        { text: 'ช่าง', value: 'mecha', width: '7%', sortable: false },
        // { text: 'PC ผู้ดูแล ', value: 'admin', width: '1%', sortable: false },
        { text: '', value: 'score', width: '1%', sortable: false }
      ],
      data: [
        {
          name: 'ชื่อลูกค้า 1',
          productName: 'ชุดครัว King Kitchen',
          PCname: 'xxx (ห้าง,สาขา)',
          date: 'ที่อยู่ 1',
          address: '08X-XXX-XXXX',
          phone: 'ที่อยู่ 1',
          status: 'ที่อยู่ 1',
          count: 'ที่อยู่ 1',
          mecha: 'ที่อยู่ 1',
          lenght: 'ที่อยู่ 1',
          admin: 'A'
        },
        {
          name: 'ชื่อลูกค้า 1',
          productName: 'ชุดครัว King Kitchen',
          PCname: 'xxx (ห้าง,สาขา)',
          date: 'ที่อยู่ 1',
          address: '08X-XXX-XXXX',
          phone: 'ที่อยู่ 1',
          status: 'ที่อยู่ 1',
          count: 'ที่อยู่ 1',
          mecha: 'ที่อยู่ 1',
          lenght: 'ที่อยู่ 1',
          admin: 'A'
        },
        {
          name: 'ชื่อลูกค้า 1',
          productName: 'ชุดครัว King Kitchen',
          PCname: 'xxx (ห้าง,สาขา)',
          date: 'ที่อยู่ 1',
          address: '08X-XXX-XXXX',
          phone: 'ที่อยู่ 1',
          status: 'ที่อยู่ 1',
          count: 'ที่อยู่ 1',
          mecha: 'ที่อยู่ 1',
          lenght: 'ที่อยู่ 1',
          admin: 'A'
        }
      ],
      menu: [
        {
          label: 'ทั้งหมด',
          value: 'All'
        },
        {
          label: `${this.$t('pc')} กรอกข้อมูล`,
          value: 'PC'
        },
        {
          label: `${this.$t('Customer')} กรอกข้อมูล`,
          value: 'Customer'
        },
        {
          label: `${this.$t('sales_approve')}`,
          value: 'Sales approve'
        },
        {
          label: `${this.$t('sales_reject')}`,
          value: 'Sales reject'
        },
        {
          label: `ทีมจัดของ ${this.$t('assign')}ช่าง`,
          value: 'Sales reject'
        },
        {
          label: 'วัดหน้างาน',
          value: 'Sales reject'
        },
        {
          label: 'ช่างเข้างาน',
          value: 'Sales reject'
        },
        {
          label: 'งานสำเร็จ',
          value: 'Sales reject'
        },
        {
          label: 'ยกเลิก',
          value: 'Sales reject'
        }
      ],
      sorts: [
        {
          label: 'ทั้งหมด',
          value: 'All'
        },
        {
          label: 'วันที่เพิ่มคำสั่งซื้อ',
          value: 'id'
        },
        {
          label: 'วันที่ติดตั้ง',
          value: 'appointmentdate'
        }
      ],
      orders: [],
      limit: 30,
      offset: 0,
      filterCondition: null,
      numberPerPageOptions: [30, 40, 50],
      showScheduleHolidays: false,
      scheduleHolidays: [],
      showQuereManagement: false,
      selectedDateQueue: null,
      // selectedDateQueue: moment().format('YYYY-MM-DD'),
      minOrder: 1,
      qtyQuotaOrder: null,
      queueList: {},
      saveloading: false
    }
  },
  computed: {
    filteredTechnician() {
      if (this.technician && this.technician.length) {
        return this.technician.map((el) => {
          let options = {}
          Object.assign(options, { name: el.technicianname, id: el.technicianid })
          // return el.technicianid
          return options
        })
      } else return []
    },
    pagelength() {
      if (this.total) {
        return Math.ceil(this.total / this.limit)
      } else {
        return 1
      }
    },
    ...mapGetters(['selectedBot'])
  },
  mounted() {
    this.getAppointmentDateList()
    this.getTechnician()
    this.getData()
    this.getHolidays()
    this.getQuere()
  },
  methods: {
    onChangeNumberOfPage(value) {
      if (value != this.limit) {
        this.limit = value
        this.getData()
      }
    },
    onSearch() {
      this.searchDialog = false
      this.offset = 0
      this.pageNumber = 1
      this.getData()
    },
    showSearch() {
      this.searchDialog = true
    },
    clearSearch() {
      this.filtersearch = {
        name: '', // ชื่อลูกค้า
        start_create_date: '', // YYYY-MM-DD
        end_create_date: '', // YYYY-MM-DD
        start_appointment_date: '', // YYYY-MM-DD
        end_appointment_date: '',
        appointmenttime: '', // เช้า, บ่าย
        phonenumber: '',
        technicianname: '', // ชื่อช่าง
        product: '', // ชื่อสินค้า,
        satisfactionStatus: null
      }
      this.offset = 0
      this.pageNumber = 1
      this.getData()
      this.searchDialog = false
    },
    onsavetime() {
      this.getAppointmentDateList()
    },
    getAppointmentDateList() {
      const currentDate = moment().format('YYYY-MM-DD')
      return new Promise((resolve) => {
        axios
          .get(`${config.serverUrl}kingkitchen/getAppointmentDateList`, {
            params: {
              currentdate: currentDate
            },
            headers: {
              AUTHORIZATION: 'Bearer xxx xxx'
            }
          })
          .then((response) => {
            this.appointmentData = response.data.data
            var result = {}
            this.appointmentData.forEach((val) => {
              var formattedDate = moment(val.appointmentdate).format('YYYY-MM-DD')
              if (result.hasOwnProperty(formattedDate)) {
                Object.assign(result[formattedDate], {
                  [val.appointmenttime]: parseInt(val.count)
                })
              } else {
                Object.assign(result, {
                  [formattedDate]: {
                    [val.appointmenttime]: parseInt(val.count)
                  }
                })
              }
            })

            this.appointmentData = result
          })
      })
    },
    timeOptions() {
      var data = [
        { name: 'เช้า', $isDisabled: false },
        { name: 'บ่าย', $isDisabled: false }
      ]
      return ['เช้า', 'บ่าย']
    },
    onsavecalendar() {
      this.calendar_dialog = false
      this.getData()
      this.getAppointmentDateList()
    },
    onChangeFilter(item) {
      this.filter = item
      this.getData()
    },
    onChangeSort(item) {
      this.sort = item
      this.getData()
    },
    closeReasonDialog() {
      this.reasonDialog = false
      this.reasonText = ''
    },
    showCalendar(item) {
      this.calendar_data = item
      this.calendar_dialog = true
    },
    showSatisfaction(item) {
      this.satisfactionData = item
      this.satisfactionDialog = true
    },
    onChangeStatus(val, item) {
      if (val == 'ยกเลิก') {
        this.reasonData = item
        this.reasonDialog = true
      } else {
        this.submitStatus(val, item)
      }
    },
    submitStatus(val, item) {
      var data = {
        pageid: this.selectedBot.pageid,
        orderid: item.id,
        adminstatus: val,
        // reason // ส่งเฉพาะ adminstatus >> ยกเลิก

        pageid: this.selectedBot.pageid,
        orderid: item.id,
        appointmentdate: moment(item.appointmentdate).format('YYYY-MM-DD'),
        appointmenttime: val
      }
      if (val === 'ยกเลิก') {
        Object.assign(data, { reason: this.reasonText })
      }

      this.$store.dispatch('loading')
      api.kingkitchenupdateOrderStatusByAdmin(data, (err, response) => {
        this.closeReasonDialog()
        this.$store.dispatch('loading')
      })
    },

    onChangeTechnichian(val, item) {
      if (!item.appointmenttime) {
        this.$swal.fire({
          text: 'กรุณาเลือกช่วงเวลา',
          type: 'error',
          confirmButtonText: this.$t('Confirm'),
          confirmButtonColor: '#f27474'
        })
      } else if (!val) {
        this.$swal.fire({
          text: 'กรุณาเลือกช่าง',
          type: 'error',
          confirmButtonText: this.$t('Confirm'),
          confirmButtonColor: '#f27474'
        })
      } else {
        var current_technician = this.technician.find((el) => el.technicianid === val)
        var data = {
          pageid: this.selectedBot.pageid,
          orderid: item.id,
          technicianid: val,
          technicianname: current_technician ? current_technician.technicianname : null
        }
        this.$store.dispatch('loading')
        api.kingkitchenapplyOrderToTechnician(data, (err, response) => {
          this.$store.dispatch('loading')
        })
      }
    },
    customTechnician(val) {
      if (this.technician && this.technician.length) {
        var result = this.technician.find((el) => el.technicianid === val)
        if (result) {
          return result.technicianname
        } else {
          return ''
        }
        return result.technicianname
      } else return ''
    },
    onChecklist(val, item) {
      this.$store.dispatch('loading')
      var data = {
        orderid: item.id,
        pageid: this.selectedBot.pageid,
        checklist: val // boolaen
      }
      api.kingkitchenverifyCheckListOrder(data, (err, response) => {
        this.$store.dispatch('loading')
      })
    },
    async onDocumentChecklist(val, item) {
      try {
        this.$store.dispatch('loading')
        const data = {
          orderid: item.id,
          pageid: this.selectedBot.pageid,
          document_check_list: val // boolaen
        }
        let response = await api.kingkitchenVerifyDocumentCheckListOrder(data)
        if (response.status) {
          this.$store.dispatch('loading')
        }
      } catch (error) {
        this.$store.dispatch('loading')
        console.error(error)
        return
      }
    },
    getProductName(item) {
      return item.productdetails.map((el) => el.product).join(', ')
    },
    changePage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        vm.offset = vm.pageNumber * this.limit - this.limit

        this.getData()
      }
    },
    getTechnician() {
      api.kingkitchenTechnicianList({ pageid: this.selectedBot.pageid }, (err, response) => {
        if (response.responsecode == 200) {
          this.technician = response.data
        }
      })
    },
    getData() {
      var data = {
        pageid: this.selectedBot.pageid,
        limit: this.limit,
        offset: this.offset
      }
      if (this.filter && this.filter.value !== 'All') {
        Object.assign(data, {
          adminstatus: this.filter.label
        })
      }
      if (this.sort && this.sort.value !== 'All') {
        Object.assign(data, {
          orderby: this.sort.value
        })
      }
      for (const key in this.filtersearch) {
        if (this.filtersearch[key]) {
          Object.assign(data, { [key]: this.filtersearch[key] })
        }
      }

      this.loading = true
      this.filterCondition = data
      api.kingkitchenGetOrders(data, (err, response) => {
        this.loading = false
        if (response.responsecode == 200) {
          this.orders = response.data
          this.total = parseInt(response.total)
        }
      })
    },

    toggleAll() {
      if (this.selected.length) this.selected = []
      else this.selected = this.desserts.slice()
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    async exportData() {
      this.$store.dispatch('loading')
      this.filterCondition.limit = 5000
      this.filterCondition.offset = 0
      await api.kingkitchenGetOrders(this.filterCondition, async (err, res) => {
        if (res.responsecode == 200) {
          let combineOrder = await res.data

          // Order
          let formatOrder = this.formatDataExport(combineOrder)
          let satisfaction = formatOrder

          formatOrder = formatOrder.map((d) => {
            return {
              orderId: d.orderId,
              name: d.name,
              goods: d.goods,
              pc_name: d.pc_name,
              date: d.date,
              place: d.place,
              phone: d.phone,
              status: d.status,
              checklist: d.checklist,
              document_check_list: d.document_check_list,
              time_range: d.time_range,
              technician: d.technician,
              customerID: d.customerID,
              queue: d.queue,
              emp_name: d.emp_name,
              pclocation: d.pclocation,
              pcbranch: d.pcbranch
            }
          })

          const data = XLSX.utils.json_to_sheet(formatOrder)
          data.A1.v = 'รหัสออเดอร์'
          data.B1.v = 'ชื่อ'
          data.C1.v = 'สินค้า'
          data.D1.v = 'ชื่อ PC'
          data.E1.v = 'วันจัดส่ง'
          data.F1.v = 'สถานที่'
          data.G1.v = 'เบอร์ติดต่อ'
          data.H1.v = 'สถานะ'
          data.I1.v = 'สินค้าครบ'
          data.J1.v = 'เอกสารครบ'
          data.K1.v = 'ช่วงเวลา'
          data.L1.v = 'ช่าง'
          data.M1.v = 'Customer ID'
          data.N1.v = 'คิวที่ใช้'
          data.O1.v = 'ชื่อพนักงาน'
          data.P1.v = 'ร้าน'
          data.Q1.v = 'สาขา'

          const wb = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(wb, data, 'คำสั่งซื้อ')

          // For problem
          let problem_data = combineOrder.filter((f) => f.problems != null)
          if (Object.keys(problem_data).length > 0) {
            problem_data = problem_data.map((d) => {
              let reason = d.problems.replace('ป,ั,ญ,ห,า,อ,ื,่,น, ,ๆ,', 'ปัญหาอื่นๆ - ')
              return {
                customerName: d.name,
                customerId: d.customerid,
                orderId: d.id,
                reason: reason
              }
            })

            const data2 = XLSX.utils.json_to_sheet(problem_data)
            data2.A1.v = 'ชื่อ'
            data2.B1.v = 'รหัสลูกค้า'
            data2.C1.v = 'รหัสออเดอร์'
            data2.D1.v = 'ปัญหาที่พบ'
            XLSX.utils.book_append_sheet(wb, data2, 'ปัญหาที่พบ')
          }
          // End Problem

          // Satisfaction
          // Installation part
          let satisfaction_installation = satisfaction.filter((f) => f.satisfactionDetail)
          if (Object.keys(satisfaction_installation).length > 0) {
            satisfaction_installation = satisfaction_installation.map((d) => {
              return {
                customerName: d.name,
                orderId: d.orderId,
                coordinate: d.satisfactionDetail.installation.coordinate,
                timeAndPolite: d.satisfactionDetail.installation.timeAndPolite,
                neatness: d.satisfactionDetail.installation.neatness,
                complacence: d.satisfactionDetail.installation.complacence
              }
            })
            const data3 = XLSX.utils.json_to_sheet(satisfaction_installation)
            data3.A1.v = 'ชื่อลูกค้า'
            data3.B1.v = 'รหัสออเดอร์'
            data3.C1.v = '1.1 การประสานงานของเจ้าหน้าที่ในการนัดหมายติดตั้ง'
            data3.D1.v = '1.2 ความตรงต่อเวลาและความสุภาพของเจ้าหน้าติดตั้ง'
            data3.E1.v = '1.3 ความเรียบร้อยและความสะดวกในการใช้งานหลังการติดตั้ง'
            data3.F1.v = '1.4 ความพึงพอใจในการได้รับบริการโดยรวม'
            XLSX.utils.book_append_sheet(wb, data3, 'ประเมินบริการติดตั้ง')
          }

          // PC part
          let satisfaction_pc = satisfaction.filter((f) => f.satisfactionDetail)
          if (Object.keys(satisfaction_pc).length > 0) {
            satisfaction_pc = satisfaction_pc.map((d) => {
              return {
                customerName: d.name,
                orderId: d.orderId,
                offer: d.satisfactionDetail.pc.offer,
                compare: d.satisfactionDetail.pc.compare,
                benefit: d.satisfactionDetail.pc.benefit,
                welcome: d.satisfactionDetail.pc.welcome,
                care: d.satisfactionDetail.pc.care
              }
            })
            const data4 = XLSX.utils.json_to_sheet(satisfaction_pc)
            data4.A1.v = 'ชื่อลูกค้า'
            data4.B1.v = 'รหัสออเดอร์'
            data4.C1.v =
              '2.1 PC ได้นำเสนอข้อมูลสินค้า, ให้ความรู้ความเข้าใจ, ประโยชน์ที่ลูกค้าจะได้รับ'
            data4.D1.v =
              '2.2 ลูกค้าได้รับทราบถึงความแตกต่างของชุดครัวคิงส์เมื่อเทียบกับชุดครัวแบรนด์อื่น'
            data4.E1.v = '2.3 ลูกค้าได้รับการแนะนำถึงสิทธิประโยชน์ และโปรโมชั่นการขายต่างๆ'
            data4.F1.v = '2.4 การต้อนรับลูกค้า, กิริยาวาจาและบุคลิกภาพของ PC'
            data4.G1.v = '2.5 การติดตามดูแลเอาใจใส่และตอบข้อสักถามลูกค้าของ PC'
            XLSX.utils.book_append_sheet(wb, data4, 'ประเมิน PC')
          }

          // Important reason to choose brain part
          let satisfaction_reason = satisfaction.filter((f) => f.satisfactionDetail != null)
          if (Object.keys(satisfaction_reason).length > 0) {
            satisfaction_reason = satisfaction_reason.map((d) => {
              return {
                customerName: d.name,
                orderId: d.orderId,
                price: d.satisfactionDetail.importantReason.price,
                beautiful: d.satisfactionDetail.importantReason.beautiful,
                property: d.satisfactionDetail.importantReason.property,
                promotion: d.satisfactionDetail.importantReason.promotion,
                freeService: d.satisfactionDetail.importantReason.freeService,
                trustBrain: d.satisfactionDetail.importantReason.trustBrain,
                pc: d.satisfactionDetail.importantReason.pc,
                design: d.satisfactionDetail.importantReason.design
              }
            })
            const data5 = XLSX.utils.json_to_sheet(satisfaction_reason)
            data5.A1.v = 'ชื่อลูกค้า'
            data5.B1.v = 'รหัสออเดอร์'
            data5.C1.v = '3.1 ราคา'
            data5.D1.v = '3.2 ความสวยงาม'
            data5.E1.v = '3.3 คุณสมบัติสินค้า เช่น กันน้ำ, กันปลวก ฯลฯ'
            data5.F1.v = '3.4 โปรโมชั่นส่งเสริมการขาย เข่น ของแถม, ส่วนลด ฯลฯ'
            data5.G1.v = '3.5 บริการส่งพร้อมติดตั้งฟรี'
            data5.H1.v = '3.6 เชื่อมั่นในแบรนด์คิงส์'
            data5.I1.v = '3.7 พนักงานขาย (PC)​'
            data5.J1.v = '3.8 การให้บริการออกแบบครัว'
            XLSX.utils.book_append_sheet(wb, data5, 'เหตุผลสำคัญที่ลูกค้าเลือกเรา')
          }

          // Suggestion part
          let satisfaction_suggestion = satisfaction.filter((f) => f.satisfactionNote != null)
          if (Object.keys(satisfaction_suggestion).length > 0) {
            satisfaction_suggestion = satisfaction_suggestion.map((d) => {
              return {
                customerName: d.name,
                orderId: d.orderId,
                note: d.satisfactionNote
              }
            })

            const data6 = XLSX.utils.json_to_sheet(satisfaction_suggestion)
            data6.A1.v = 'ชื่อลูกค้า'
            data6.B1.v = 'รหัสออเดอร์'
            data6.C1.v = 'ข้อเสนอแนะ'
            XLSX.utils.book_append_sheet(wb, data6, 'ข้อเสนอแนะการให้บริการ')
          }

          XLSX.writeFile(wb, 'export.xlsx')
          this.$store.dispatch('loading')
        }
      })
    },
    formatDataExport(orders) {
      const formatOrder = orders.map((d) => {
        return {
          orderId: d.id,
          name: d.name,
          goods: d.productdetails
            .map((d2) => {
              return (
                '{' +
                d2.product +
                ' รูปแบบการติดตั้ง : ' +
                d2.format +
                ' , ซิงก์ : ' +
                d2.sink +
                ' , อุปกรณ์อื่น ๆ :' +
                d2.other +
                ' หมายเหตุ : ' +
                d2.remark +
                '}'
              )
            })
            .toString(),
          pc_name: d.pcname,
          date: moment(d.appointmentdate).format('D/MM/YYYY'),
          place:
            d.address +
            ' เขต' +
            d.district +
            ' แขวง' +
            d.subdistrict +
            ' ' +
            d.zipcode +
            ' จังหวัด' +
            d.province,
          phone: d.phonenumber,
          status: d.adminstatus,
          checklist: d.checklist ? 'ครบ' : 'None',
          time_range: d.appointmenttime,
          technician: d.technicianname,
          customerID: d.customerid,
          queue: d.amount,
          emp_name: d.pcname,
          pclocation: d.pclocation,
          pcbranch: d.pcbranch,
          satisfactionDetail: d.satisfactiondetail ? JSON.parse(d.satisfactiondetail) : null,
          satisfactionNote: d.satisfactionnote ? d.satisfactionnote : null
        }
      })
      return formatOrder
    },
    onSaveHolidays() {
      var data = {
        pageid: this.selectedBot.pageid,
        holidays: this.scheduleHolidays
      }

      this.loading = true
      api.kingkitchenSetHoliday(data, (err, response) => {
        if (response.responsecode == 200) {
          this.loading = false
          this.getHolidays()
        }
      })
    },
    getHolidays() {
      var data = {
        pageid: this.selectedBot.pageid
      }
      api.kingkitchenGetHoliday(data, (err, response) => {
        if (response.responsecode == 200) {
          this.scheduleHolidays = response.holidays
        }
      })
    },
    allowedDates(val) {
      if (this.scheduleHolidays.includes(val)) {
        return false
      } else {
        return true
      }
    },
    getQuere() {
      var data = {
        pageid: this.selectedBot.pageid
      }
      api.kingkitchenGetQueue(data, (err, response) => {
        if (response.responsecode == 200) {
          this.queueList = response.data
        }
      })
    },
    onCheckQuotaOrder() {
      let selectedDate = this.selectedDateQueue
      var day = moment(selectedDate).format('dddd')
      let qtyOrderBySelected = null

      let allQueueOrder = this.queueList
      if (allQueueOrder) {
        let key = Object.keys(allQueueOrder).find((key) => selectedDate.includes(key))
        if (key) {
          qtyOrderBySelected = allQueueOrder[key]
        }
      }

      if (!qtyOrderBySelected) {
        if (['Saturday', 'Sunday'].includes(day)) {
          qtyOrderBySelected = 8
        } else {
          qtyOrderBySelected = 10
        }
      }

      this.qtyQuotaOrder = qtyOrderBySelected
    },
    addOrder() {
      this.qtyQuotaOrder++
    },
    reduceOrder() {
      this.qtyQuotaOrder--
    },
    onSaveQueue() {
      if (!this.selectedDateQueue) {
        this.$swal.fire({
          text: 'กรุณาเลือกวันที่ต้องการจัดการจำนวนคิวช่าง',
          type: 'error',
          confirmButtonText: this.$t('Confirm'),
          confirmButtonColor: '#f27474'
        })
        return
      }

      let allQueueOrder = this.queueList
      let selectedDate = this.selectedDateQueue
      let qty = this.qtyQuotaOrder

      let isExistKey = Object.keys(allQueueOrder).find((key) => selectedDate.includes(key))
      if (isExistKey) {
        allQueueOrder[isExistKey] = qty
      } else {
        Object.assign(allQueueOrder, { [selectedDate]: qty })
      }

      var data = {
        pageid: this.selectedBot.pageid,
        data: allQueueOrder
      }

      this.saveloading = true
      api.kingkitchenSetQueue(data, (err, response) => {
        if (response && response.responsecode == 200) {
          this.queueList = response.data
          this.saveloading = false
          this.onCloseQuereManagementDialog()
        }
      })
    },
    onCloseQuereManagementDialog() {
      this.showQuereManagement = false
      this.qtyQuotaOrder = null
      this.selectedDateQueue = null
    }
  }
}
</script>

<style lang="scss" scoped>
.satisfactionTrue {
  background: #c5f982;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/kingKitchen/adminMenu/Dashboard.vue